export interface Crud {
  crudKey?: CrudCode;
  uuid?: string;
  dataInsUserId?: string;
  dataInsUserNm?: string;
  dataInsUserIp?: string;
  dataInsDtm?: string;
  dataUpdUserId?: string;
  dataUpdUserNm?: string;
  dataUpdUserIp?: string;
  dataUpdDtm?: string;
}

export enum CrudCode {
  CREATE = 'C',
  READ = 'R',
  UPDATE = 'U',
  DELETE = 'D',
}

export enum EditType {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
}
